import { Stack, Theme, Typography, useMediaQuery } from "@mui/material";
import { FullPlaceFragment } from "@sinch/core/entities/fragments.types";
import { TransportDirection } from "@sinch/core/entities/serverEnums.types";
import { useFormat } from "@sinch/core/hooks/format";
import { isNotNil } from "ramda-adjunct";
import React, { FC } from "react";
import { DateRange } from "@sinch/components";
import { useTransportDirection } from "@sinch/components/application/Transport/useTransportDirection";

export type TransportNameProps = {
  id?: number | string | null;
  direction?: TransportDirection | null;
  place?: FullPlaceFragment | null;
} & (
  | {
      beginning: Date;
      end: Date;
    }
  | {
      beginning?: undefined;
      end?: undefined;
    }
);

export const TransportName: FC<TransportNameProps> = ({ direction, place, beginning, end }) => {
  const { address } = useFormat();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const { getTransportDirectionLabel } = useTransportDirection();

  return (
    <Stack alignItems="center" direction="row" flexWrap={isMobile ? "wrap" : "nowrap"} spacing={1}>
      {direction && (
        <Typography
          component="span"
          sx={(theme) => ({
            fontSize: theme.typography.pxToRem(15),
          })}
        >
          {getTransportDirectionLabel(direction)}
        </Typography>
      )}
      {isNotNil(place) && (
        <Typography
          component="span"
          sx={(theme) => ({
            fontSize: theme.typography.pxToRem(15),
          })}
        >
          {address.full(place)}
        </Typography>
      )}
      {beginning && end && (
        <Typography
          component="span"
          sx={({ typography }) => ({
            whiteSpace: "nowrap",
            fontSize: typography.body1.fontSize,
          })}
        >
          <DateRange end={end} start={beginning} />
        </Typography>
      )}
    </Stack>
  );
};
